<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useOrganizationStore } from "~/modules/organization/stores/useOrganizationStore";
import { PATH_USER_MANAGEMENT_USERS } from "~/modules/user/constants";

const { currentOrganization } = storeToRefs(useOrganizationStore());
</script>

<template>
  <page-component>
    <log-list
      :organization-code="currentOrganization?.code"
      :path-context="PATH_USER_MANAGEMENT_USERS"
    />
  </page-component>
</template>
